export default __webpack_public_path__ + "static/media/Group 527.c52bc444.png";